import { useEffect } from 'react'

export function useRefetchOnFocus(callback: (isBackground?: boolean) => void) {
  useEffect(() => {
    const handleFocus = () => {
      if (document.visibilityState === 'visible') {
        callback(true)
      }
    }

    window.addEventListener('focus', handleFocus)
    window.addEventListener('visibilitychange', handleFocus)

    return () => {
      window.removeEventListener('focus', handleFocus)
      window.removeEventListener('visibilitychange', handleFocus)
    }
  }, [callback])
}
